import { useState, lazy, Suspense } from 'react';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import Showroom from '@/components/Showroom';
import BrandSection from '@/components/BrandSection';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import BookingModal from '@/components/BookingModal';

const Services = lazy(() => import('@/components/Services'));
const FAQ = lazy(() => import('@/components/FAQ'));
const Testimonials = lazy(() => import('@/components/Testimonials'));
const ScrollToTop = lazy(() => import('@/components/ScrollToTop'));
const WhatsAppButton = lazy(() => import('@/components/WhatsAppButton'));
const CookieConsent = lazy(() => import('@/components/CookieConsent'));

import contessinaDiningLuxury from '@/assets/contessina-dining-luxury.webp';
import contessinaBedroom from '@/assets/contessina-bedroom.webp';
import contessinaYacht from '@/assets/contessina-yacht.webp';
import contessinaKitchenClassic from '@/assets/contessina-kitchen-classic.webp';
import contessinaDiningClassic from '@/assets/contessina-dining-classic.webp';

import barjBuzzoniFloral from '@/assets/barjbuzzoni-floral-dark.webp';
import barjBuzzoniWaves from '@/assets/barjbuzzoni-waves-light.webp';
import barjBuzzoniBamboo from '@/assets/barjbuzzoni-bamboo-gold.webp';
import barjBuzzoniCircle from '@/assets/barjbuzzoni-circle-blue.webp';
import barjBuzzoniTriptych from '@/assets/barjbuzzoni-triptych-luxury.webp';

import pataviumartModern from '@/assets/pataviumart-chandelier-modern.webp';
import pataviumartClassic from '@/assets/pataviumart-chandelier-classic.webp';
import pataviumartLamps from '@/assets/pataviumart-lamps-marble.webp';
import pataviumartBlack from '@/assets/pataviumart-chandelier-black.webp';
import pataviumartBathroom from '@/assets/pataviumart-bathroom-loft.webp';

import stoneBathroomWhite from '@/assets/stone-bathroom-white.webp';
import stoneBathroomDark from '@/assets/stone-bathroom-dark.webp';
import stoneLivingMarble from '@/assets/stone-living-marble.webp';
import stoneKitchenBeige from '@/assets/stone-kitchen-beige.webp';
import contessinaSpa from '@/assets/contessina-spa.webp';

const brandData = [
  {
    id: 'la-contessina',
    brandKey: 'laContessina',
    images: [
      contessinaDiningLuxury,
      contessinaBedroom,
      contessinaYacht,
      contessinaKitchenClassic,
      contessinaDiningClassic,
    ],
    reverse: false,
    videoId: '3bNgyOSNH_U',
  },
  {
    id: 'barj-buzzoni',
    brandKey: 'barjBuzzoni',
    images: [
      barjBuzzoniFloral,
      barjBuzzoniWaves,
      barjBuzzoniBamboo,
      barjBuzzoniCircle,
      barjBuzzoniTriptych,
    ],
    reverse: true,
  },
  {
    id: 'pataviumart',
    brandKey: 'pataviumart',
    images: [
      pataviumartClassic,
      pataviumartModern,
      pataviumartBlack,
      pataviumartLamps,
      pataviumartBathroom,
    ],
    reverse: false,
  },
  {
    id: 'italian-stone-source',
    brandKey: 'italianStoneSource',
    images: [
      stoneLivingMarble,
      stoneBathroomDark,
      stoneBathroomWhite,
      stoneKitchenBeige,
      contessinaSpa,
    ],
    reverse: true,
  },
];

const Index = () => {
  const [bookingOpen, setBookingOpen] = useState(false);
  const openBooking = () => setBookingOpen(true);

  return (
    <div className="min-h-screen bg-background">
      <Header onBooking={openBooking} />
      <Hero onBooking={openBooking} />
      <Showroom />
      {brandData.map((brand) => (
        <BrandSection key={brand.id} {...brand} />
      ))}
      <Suspense fallback={null}>
        <Services />
        <FAQ />
        <Testimonials />
      </Suspense>
      <Contact onBooking={openBooking} />
      <Footer />
      <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} />
      <Suspense fallback={null}>
        <ScrollToTop />
        <WhatsAppButton />
        <CookieConsent />
      </Suspense>
    </div>
  );
};

export default Index;
